import { useEffect } from 'react'

import { useAuth } from '@/features/auth'
import { GlobalLoaderComponent } from '@/utils/globalLoaders/GlobalLoaders'

import { isValidLanguageCode } from './language'
import { useLocalisation } from './useLocalisation'

export const LocalisationLoader: GlobalLoaderComponent = () => {
  const { user } = useAuth()
  const { currentLanguage, setLibrariesLocale, updatePreferredLanguage } = useLocalisation()

  const userId = user?._id

  useEffect(() => {
    const language = currentLanguage
    if (isValidLanguageCode(language)) {
      setLibrariesLocale(language)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentLanguage])

  // Covering the case where we need synchronize the local language with the user's preferred language.
  useEffect(() => {
    if (userId && user.preferredLanguage !== currentLanguage && isValidLanguageCode(currentLanguage)) {
      updatePreferredLanguage(currentLanguage)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userId])

  return null
}
